<ng-container *transloco="let t">
  @if (
    {
      topics: topics$ | async
    };
    as ctx
  ) {
    <cft-nav-list-item-expandable
      [isExpanded]="false"
      [title]="t('navbar.articles')"
      [testIdList]="'articles-menu-list'"
    >
      <ul cft-nav-list class="mt-1">
        <li>
          <a
            cft-nav-list-item
            [indentation]="1"
            id="nav-articles"
            [routerLink]="linkService.localizedPathTo(APPLICATION_ROUTES.ARTICLE_OVERVIEW)"
            routerLinkActive="active"
          >
            {{ t('navbar.overview') }}
          </a>
        </li>
        @for (topic of ctx.topics; track topic; let i = $index) {
          <li
            [indentation]="1"
            [isExpanded]="false"
            cft-nav-list-item-expandable
            [title]="topic.breadcrumbTitle || topic.title"
            [testIdList]="'topic-item-' + i"
            #parent
          >
            <ul cft-nav-list class="mt-1">
              <li>
                <a [indentation]="2" cft-nav-list-item [routerLink]="topic.path" routerLinkActive="active">
                  {{ t('navbar.overview') }}
                </a>
              </li>
              @defer (on hover(parent); on interaction(parent)) {
                @for (item of articlesFromTopic$(topic.id) | async; track item) {
                  <li [title]="item.title">
                    <a cft-nav-list-item [indentation]="2" [routerLink]="item.path" routerLinkActive="active">
                      {{ item.title }}
                    </a>
                  </li>
                }
              } @placeholder (minimum 150ms) {
                <li cft-nav-list-item [indentation]="2" class="mx-xl h-[25px] animate-pulse rounded-1 bg-grey-20"></li>
                <li cft-nav-list-item [indentation]="2" class="mx-xl h-[25px] animate-pulse rounded-1 bg-grey-20"></li>
              }
            </ul>
          </li>
        }
      </ul>
    </cft-nav-list-item-expandable>
  }
</ng-container>
